import { useQuery } from '@apollo/react-hooks';
import GetUserStatsAdmin from '../gql/queries/get-user-stats-admin';

const useUserAnalytics = () => {
  // Use the getUserStatsAdmin query
  const { data, loading, error } = useQuery(GetUserStatsAdmin, {
    fetchPolicy: 'cache-and-network',
  });

  // Transform the API response to match component expectations
  if (loading) {
    return {
      loading: true,
      error: null,
      totalUsers: 0,
      avgLifetimeValue: 0,
      avgEventsPerUser: 0,
      avgUsersPerEvent: 0,
      superFans: 0,
      stats: null,
    };
  }

  if (error) {
    return {
      loading: false,
      error,
      totalUsers: 0,
      avgLifetimeValue: 0,
      avgEventsPerUser: 0,
      avgUsersPerEvent: 0,
      superFans: 0,
      stats: null,
    };
  }

  const stats = data?.getUserStatsAdmin;

  return {
    loading: false,
    error: null,
    totalUsers: stats?.totalUsers?.value || 0,
    avgLifetimeValue: stats?.avgLifetimeValue?.value || 0,
    avgEventsPerUser: stats?.avgEventsPerUser?.value || 0,
    avgUsersPerEvent: stats?.avgUsersPerEvent?.value || 0,
    superFans: stats?.superFans?.value || 0,
    stats: stats || null,
  };
};

export default useUserAnalytics;
